import ArtBoard from '@components/ArtBoard/ArtBoard'
import { useInitPreview } from '@components/PreviewPage/hooks'
import type React from 'react'

export const PreviewPage: React.FC = () => {
  useInitPreview()
  return <ArtBoard />
}
